module.exports = require('@nerdwallet/structured-content-core/hash');
